function t(e) {
  return (l) => {
    l ? e.value = l.$el : e.value = null;
  };
}
export {
  t as createRefSetter
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/create-ref-setter.js
// module id = 900
// module chunks = 41